import store from '~store';
import router from '~router';

export default {
    /**
     * Handle response, show snackbar messages and redirect on another route if need
     * @param {object} resp
     * @param {string} successMessage
     * @param {string} errorMessage
     * @param {string} routeName
     */
    handleResponse(
        resp,
        successMessage = undefined,
        errorMessage = undefined,
        routeName = undefined
    ) {
        // Check success response
        if (resp.ok || resp.status === 200) {
            // Show success message
            if (successMessage && successMessage.length > 0) {
                store.dispatch('snackbar/showMessage', successMessage);
            }

            // Redirect to another route
            if (routeName && routeName.length > 0) {
                router.push({ name: routeName });
            }
        } else {
            let errorMessageText;
            let obj;

            if (resp.status === 422) {
                if (
                    resp.data &&
                    resp.data.message &&
                    resp.data.message.length &&
                    resp.data.message[0].constraints
                ) {
                    obj = resp.data.message[0].constraints;
                } else if (
                    resp.data &&
                    resp.data.message &&
                    resp.data.message.length &&
                    resp.data.message[0].children &&
                    resp.data.message[0].children.length &&
                    resp.data.message[0].children[0] &&
                    resp.data.message[0].children[0].constraints
                ) {
                    obj = resp.data.message[0].children[0].constraints;
                }

                if (typeof obj === 'object' && Object.keys(obj).length) {
                    errorMessageText = obj[Object.keys(obj)[0]];
                }

                if (
                    resp.data &&
                    resp.data.message &&
                    typeof resp.data.message === 'string'
                ) {
                    errorMessageText = resp.data.message;
                }
            } else {
                errorMessageText =
                    resp && resp.data && resp.data.message
                        ? resp.data.message
                        : null;
            }

            if (errorMessage) {
                errorMessageText = errorMessage;
            }

            // Show error message
            if (errorMessageText) {
                store.dispatch('snackbar/showMessage', errorMessageText);
            } else {
                // Redirect to another route
                if (routeName && routeName.length > 0) {
                    router.push({ name: routeName });
                }
            }
        }
    },
};
